import vueMainInstance from "../../main";

export default class RoleMapping {
  constructor() {
    this.name = "";
    this.auth_items = [];
  }

  load(name) {
    vueMainInstance.axios
      .post("settings/role-mapping/mapping-details", {
        name: name
      })
      .then(resp => {
        this.name = resp.data.name;
        this.auth_items = resp.data.auth_items;
      });
  }

  save() {
    return new Promise((resolve, reject) => {
      vueMainInstance.axios
        .post("settings/role-mapping/save", this)
        .then(() => {
          resolve();
        })
        .catch(resp => {
          reject(resp.data);
        });
    });
  }
}
